import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./CaseStudyCards.css";
import Heading from "../../../utls/Heading";

const CaseStudyCards = () => {
  return (
    <>
      <div className="CaseStudyCards grotesk-headings">
        <div className="container">
          <div className="row">
            <Heading className="customheadings text-center">
              <span>Case </span>Studies
            </Heading>
          </div>

          <div className="row d-flex mt-md-4">
            <div className="col-lg-6 mt-3 stretch">
              <div className="CaseStudyCards-box d-flex">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/casestudy1.png"
                  alt=""
                  className="casestudy1-img"
                  loading="lazy"
                />
                <h5 className="mt-4 px-3 headings">
                  Client Success Stories Redefine Corporate Travel
                </h5>
                <p className="case-study-card-description mt-1 px-3">
                  See how Blueberry Travel transformed the corporate travel
                  experience, delivering efficiency, cost savings, and traveler
                  satisfaction for industry leaders.
                </p>
                <div className="carouselCaption px-3">
                  <a href="">
                    <button className="btn bg-transparent text-dark mt-lg-3 grotesk-headings fw-bold text-uppercase">
                      Find out more
                    </button>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6 mt-3 stretch">
              <div className="CaseStudyCards-box d-flex">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/casestudy2.png"
                  alt=""
                  className="casestudy1-img"
                  loading="lazy"
                />
                <h5 className="mt-4 px-3 headings">
                  Case Study: Global Reach, Local Expertise
                </h5>
                <p className="case-study-card-description mt-1 px-3">
                  Learn how our personalized travel management solutions enabled
                  a multinational firm to achieve cost-effective, seamless, and
                  compliant travel across continents.
                </p>
                <div className="carouselCaption px-3">
                  <a href="">
                    <button className="btn bg-transparent text-dark mt-lg-3 grotesk-headings fw-bold text-uppercase">
                      Find out more
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row d-flex mt-4">
            <div className="col-lg-6 mt-3">
              <div className="CaseStudyCards-box d-flex">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/casestudy3.png"
                  alt=""
                  className="casestudy1-img"
                  loading="lazy"
                />
                <h5 className="mt-4 px-3 headings">
                  Travel sustainability for a better environment
                </h5>
                <p className="case-study-card-description mt-1 px-3">
                  Learn how Blueberry Travel helped minimize carbon footprints
                  by 30% with innovative travel policies and eco-friendly
                  accommodations for better environment.
                </p>
                <div className="carouselCaption px-3">
                  <a href="">
                    <button className="btn bg-transparent text-dark mt-lg-3 grotesk-headings fw-bold text-uppercase">
                      Find out more
                    </button>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6 mt-3">
              <div className="CaseStudyCards-box d-flex">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/cassestudy4.png"
                  alt=""
                  className="casestudy1-img"
                  loading="lazy"
                />
                <h5 className="mt-4 px-3 headings">
                  Travel management for growing startup
                </h5>
                <p className="case-study-card-description mt-1 px-3">
                  Discover how Blueberry Travel helped a growing venture craft a
                  flexible travel program, allowing it to scale operations
                  smoothly while maintaining cost control.
                </p>
                <div className="carouselCaption px-3">
                  <a href="">
                    <button className="btn bg-transparent text-dark mt-lg-3 grotesk-headings fw-bold text-uppercase">
                      Find out more
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row d-flex mt-4">
            <div className="col-lg-6 mt-3">
              <div className="CaseStudyCards-box d-flex">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/casestudy5.png"
                  alt=""
                  className="casestudy1-img"
                  loading="lazy"
                />
                <h5 className="mt-4 px-3 headings">
                  Customized Travel Solutions for a Retail Brand
                </h5>
                <p className="case-study-card-description mt-1 px-3">
                  Read about our success in providing personalized travel
                  arrangements for a retail company, ensuring their clients and
                  executives receive quality service and exclusive experiences.
                </p>
                <div className="carouselCaption px-3">
                  <a href="">
                    <button className="btn bg-transparent text-dark mt-lg-3 grotesk-headings fw-bold text-uppercase">
                      Find out more
                    </button>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6 mt-3">
              <div className="CaseStudyCards-box d-flex">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/casestudy6.png"
                  alt=""
                  className="casestudy1-img"
                  loading="lazy"
                />
                <h5 className="mt-4 px-3 headings">
                  Optimizing Travel for a Global Financial Firm
                </h5>
                <p className="case-study-card-description mt-1 px-3 ">
                  See how our travel management strategy saved a multinational
                  financial services company over $2 million annually while
                  upgrading compliance and travel satisfaction.{" "}
                </p>
                <div className="carouselCaption px-3">
                  <a href="">
                    <button className="btn bg-transparent text-dark mt-lg-3 grotesk-headings fw-bold text-uppercase">
                      Find out more
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CaseStudyCards;
